<template>
  <div
    id="app"
    class="h-100"
    :class="[skinClasses]"
  >
    <div v-if="test">
      <b-col
          md="12">
        <div class="bg-danger bg-darken-2 colors-container rounded text-white height-100 d-flex align-items-center justify-content-center mr-1 ml-1 my-1 shadow"><span>Es besteht derzeit ein Problem mit der Verbindung</span></div>
      </b-col>

    </div>
    <div v-else>
      <component :is="layout">
        <router-view />
      </component>
      <FloatingChat v-if="isLoggedIn" />
    </div>
  </div>
</template>


<script>

// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import ability from '@/libs/acl/ability'
import FloatingChat from '@/@core/components/chat/FloatingChat.vue'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')

export default {
  components: {

    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
    FloatingChat,
  },
  data() {
    return {
      Username: "",
      test: false
    }
  },
  async created() {
    const isLocalDevelopment = process.env.NODE_ENV === 'development'
      && ['localhost', '127.0.0.1'].includes(window.location.hostname)

    if (isLocalDevelopment) {
      const localRights = Array.from({ length: 1000 }, (_, index) => `R${index}`)
      const localAbilities = localRights.map(subject => ({
        action: 'read',
        subject,
      }))

      this.$store.state.user.Username = 'Lokale Entwicklung'
      this.$store.state.user.UserType = 'Administrator'
      await this.$store.dispatch('SET_RIGHTS', localRights)
      ability.update(localAbilities)
      return
    }

    try {
      if (this.$store.state.user.UserSessionToken === "") {
        if (this.$cookies.get("jwt")) {

          console.log("Start JwtCheck")
          console.log("Start JwtCheck Cookie " + this.$cookies.get('jwt'))
          const resp = await this.$http.post('/authentication/token/check', JSON.stringify({
            Jwt: this.$cookies.get("jwt"),
          }));

          if (resp.data.success) {
            let newT = '';

            newT = resp.data.refreshToken;
            await this.$cookies.set('jwt', newT);
            console.log("await this.$cookies.set('jwt', newT): " + this.$cookies.get('jwt'))
            this.$socket.emit('authSocketUser', { jwt: this.$cookies.get('jwt') });
            this.pingTime = Date.now();
            this.$socket.emit('ping2', { agent: btoa(navigator.userAgent) });

            this.$store.state.appConfig.layout.skin = resp.data.user.FrontendSettings.Skin;
            this.$store.state.appConfig.layout.type = resp.data.user.FrontendSettings.Type;
            this.$store.state.appConfig.layout.menu.hidden = resp.data.user.FrontendSettings.MenuHidden;
            this.$store.state.user.Username = resp.data.user.Username
            this.$store.state.user.UserType = resp.data.user.UserType
            this.$store.state.user.UserId = resp.data.user.UserId

            let r = [];
            let rAbility = [];

            if (resp.data.user.UserType == "TravelAgency") {
              r.push("TAR" + 0);
              rAbility.push({
                action: 'read',
                subject: 'TAR' + 0,
              });
            } else if (resp.data.user.UserType == "Administrator") {
              r.push("R" + 0);
              rAbility.push({
                action: 'read',
                subject: 'R' + 0,
              });

              Object.keys(resp.data.user.Rights).forEach(key => {
                r.push("R" + key);
                rAbility.push({
                  action: 'read',
                  subject: 'R' + key,
                });
              });
            }

            await this.$store.dispatch('SET_RIGHTS', r);
            ability.update(rAbility);

            await this.$store.dispatch('SET_TOKEN', this.$cookies.get("jwt"));
          } else {
            this.$router.push({ name: 'login' });
          }

          console.log("finish JwtCheck")
          console.log("finish JwtCheck Cookie " + this.$cookies.get('jwt'))
        } else {
          if (!location.href.includes("/dc/")) {
            this.$router.push({ name: 'login' });
          }
        }
      } else {
        console.log("????????????????????");
      }
    } catch (err) {
      console.error(err);
    }
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {

    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
    isLoggedIn() {
      return !!this.$store.state.user.UserSessionToken || !!this.$cookies.get('jwt')
    },
  },
  beforeCreate() {

    // Set colors in theme
    const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark', 'purple']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement)
        .value
        .trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement)
        .value
        .slice(0, -2))
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },
  setup() {
    const {
      skin,
      skinClasses,
    } = useAppConfig()

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
    }
  },
}
</script>
